import { render } from "./ClinicalLabDetail.vue?vue&type=template&id=7a4c4e54"
import script from "./ClinicalLabDetail.vue?vue&type=script&lang=js"
export * from "./ClinicalLabDetail.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__